
import Vuex from 'vuex'

export const store =  new Vuex.Store({
	state: {
		mainView: 'product-main',
		mvProp1: '',
		mvProp2: '',
		mvProp3: [],

		userBuildList: [],
		userBuildComp: '0',

		allProdList: [],
		productComp: '0',

		allItemList: [],
		itemComp: '0',
	},

	mutations: {
		setMainView(state, payload) { state.mainView = payload.name; state.mvProp1 = payload.prop1; state.mvProp2 = payload.prop2; state.mvProp3 = payload.prop3 },

		setBuilds(state, payload) { state.userBuildList = payload.info; state.userBuildComp = payload.info1; },
		setBuildsComp(state, payload) { state.userBuildComp = payload.info1; },

		setProducts(state, payload) { state.allProdList = payload.info; state.productComp = payload.info1; },
		setProductsComp(state, payload) { state.productComp = payload.info1; },

		setItems(state, payload) { state.allItemList = payload.info; state.itemComp = payload.info1; },
		setItemsComp(state, payload) { state.itemComp = payload.info1; },

  	},

	actions: {
		getMainView(context, payload) { context.commit("setMainView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2, prop3: payload.prop3 })  },
		getAllUserBuilds(context, payload) {
			context.commit("setBuildsComp", { info1: '0' }) 
			axios.get('/utility/user/contact/getallbuildsbyuser')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setBuilds", { info: b, info1: '1' }) 
	          	});
		},
		getAllProducts(context, payload) {
			context.commit("setProductsComp", { info1: '0' }) 
			axios.get('/admin/utility/product/getallproducts')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setProducts", { info: b, info1: '1' }) 
	          	});
	    },
	    getAllItems(context, payload) {
			context.commit("setItemsComp", { info1: '0' }) 
			axios.get('/admin/utility/product/getallitems')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setItems", { info: b, info1: '1' }) 
	          	});
	    }
	}

})